import { render, staticRenderFns } from "./TarafColumn.vue?vue&type=template&id=5cbe645f&scoped=true"
import script from "./TarafColumn.vue?vue&type=script&lang=ts"
export * from "./TarafColumn.vue?vue&type=script&lang=ts"
import style0 from "./TarafColumn.vue?vue&type=style&index=0&id=5cbe645f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cbe645f",
  null
  
)

export default component.exports